// listing_id format used across the admin: first 2 digits = building number,
// remaining 4 = apartment number on that building.
// Example: 141301 → bldg 14, apt 1301.

export function bldgOf(listingId: number): number {
  return Math.floor(listingId / 10000);
}

export function aptOf(listingId: number): number {
  return listingId % 10000;
}
